import React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";

import CircularProgress from "@mui/material/CircularProgress";
import LearnTextEmbed from "../LearnPanelComponents/LearnCopy/LearnTextEmbed";

type StrategyIntroProps = {
  strategyOptions: { [key: string]: any };
  spinAddStrategy: string | undefined;
  handleAdd?: (strategy?: string) => void;
};

function StrategyIntro(props: StrategyIntroProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        maxWidth: "800px",
      }}
    >
      {/* // TODO: show more elements down there below */}
      {Object.entries(props.strategyOptions).map(([key, value]) => (
        <div key={key}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              position: "sticky",
              top: 0,
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Box
              sx={{
                ml: 2,
              }}
            >
              <IconButton
                onClick={() => props.handleAdd !== undefined && props.handleAdd(key)}
                disabled={props.spinAddStrategy === key}
              >
                {<AddIcon />}
              </IconButton>
            </Box>
            <Typography
              variant="h6"
              color={theme.palette.primary.main}
              sx={{
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {key}
            </Typography>
            {props.spinAddStrategy === key ? (
              <Box sx={{ ml: 2, display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                <CircularProgress size="1.25rem" />
              </Box>
            ) : null}
          </Box>
          <Typography variant="body1" component="div" color={theme.palette.text.primary} sx={{ px: 2, pb: 1 }}>
            {value.useCaseDescription ? <LearnTextEmbed content={value.useCaseDescription.trim() + " "} /> : null}
            <LearnTextEmbed content={value.description.trim()} />
          </Typography>
        </div>
      ))}
    </Box>
  );
}

export default StrategyIntro;
